import React, { useState } from "react";
import Button from "../../../componentLibrary/Button";
import Modal from "../../../componentLibrary/Modal";

export default function ModalComponents() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="space-y-2">
      <h2 className="underline">Messaging Components</h2>

      <h3>Modals</h3>
      <div className="mb-4 p-4 bg-gray-50 rounded-lg">
        <h4 className="text-sm font-medium text-gray-900 mb-2">Usage:</h4>
        <p className="text-sm text-gray-700">
          Overlay dialogs used throughout the application for focused user
          interactions. Used for form submissions, confirmations, content
          creation, and user management. Features customizable sizes, titles,
          and content areas for various use cases including user profile
          management, content creation, and data editing.
        </p>
      </div>
      <Button className="w-full" onClick={() => setIsModalOpen(!isModalOpen)}>
        Open Modal
      </Button>
      <Modal
        isOpen={isModalOpen}
        title="Hello"
        size="md"
        onCloseModal={() => setIsModalOpen(false)}
      >
        Hello
      </Modal>
    </div>
  );
}
